import React from 'react';

export default () => <svg xmlns="http://www.w3.org/2000/svg" width="13.672" height="13.672" viewBox="0 0 13.672 13.672">
  <g transform="translate(13.672) rotate(90)">
    <path
      d="M5.977,11.958H16.359L11.573,7.173l1.239-1.2,6.836,6.836-6.836,6.836-1.2-1.2,4.742-4.785H5.977Z" 
      transform="translate(-5.977 -5.977)"
    />
  </g>
</svg>